namespace TabAurous.HR {
    export interface IncomeTaxSlabDetailsForm {
        IncomeTaxSlabId: Serenity.IntegerEditor;
        FromAmount: Serenity.DecimalEditor;
        ToAmount: Serenity.DecimalEditor;
        PerecentDeduction: Serenity.DecimalEditor;
        Condition: Serenity.StringEditor;
        Value: Serenity.DecimalEditor;
    }

    export class IncomeTaxSlabDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'HR.IncomeTaxSlabDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IncomeTaxSlabDetailsForm.init)  {
                IncomeTaxSlabDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.StringEditor;

                Q.initFormType(IncomeTaxSlabDetailsForm, [
                    'IncomeTaxSlabId', w0,
                    'FromAmount', w1,
                    'ToAmount', w1,
                    'PerecentDeduction', w1,
                    'Condition', w2,
                    'Value', w1
                ]);
            }
        }
    }
}
